module.exports = __webpack_public_path__ + "static/media/Avatars_Other-26.a7185649.png";